var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card',{attrs:{"title":"Incentifyer Accounts","subtitle":''}},[_c('div',[_c('Incentifyer-Accounts-Table')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }